import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import { makeOfflineTransport, serializeEnvelope, parseEnvelope } from '@sentry/core';
import { WINDOW } from '../helpers.js';
import { makeFetchTransport } from './fetch.js';

// 'Store', 'promisifyRequest' and 'createStore' were originally copied from the 'idb-keyval' package before being
// modified and simplified: https://github.com/jakearchibald/idb-keyval
//
// At commit: 0420a704fd6cbb4225429c536b1f61112d012fca
// Original license:

// Copyright 2016, Jake Archibald
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

function promisifyRequest(request) {
  return new Promise(function (resolve, reject) {
    // @ts-expect-error - file size hacks
    request.oncomplete = request.onsuccess = function () {
      return resolve(request.result);
    };
    // @ts-expect-error - file size hacks
    request.onabort = request.onerror = function () {
      return reject(request.error);
    };
  });
}

/** Create or open an IndexedDb store */
function createStore(dbName, storeName) {
  var request = indexedDB.open(dbName);
  request.onupgradeneeded = function () {
    return request.result.createObjectStore(storeName);
  };
  var dbp = promisifyRequest(request);
  return function (callback) {
    return dbp.then(function (db) {
      return callback(db.transaction(storeName, 'readwrite').objectStore(storeName));
    });
  };
}
function keys(store) {
  return promisifyRequest(store.getAllKeys());
}

/** Insert into the end of the store */
function _push(store, value, maxQueueSize) {
  return store(function (store) {
    return keys(store).then(function (keys) {
      if (keys.length >= maxQueueSize) {
        return;
      }

      // We insert with an incremented key so that the entries are popped in order
      store.put(value, Math.max.apply(Math, _toConsumableArray(keys).concat([0])) + 1);
      return promisifyRequest(store.transaction);
    });
  });
}

/** Insert into the front of the store */
function _unshift(store, value, maxQueueSize) {
  return store(function (store) {
    return keys(store).then(function (keys) {
      if (keys.length >= maxQueueSize) {
        return;
      }

      // We insert with an decremented key so that the entries are popped in order
      store.put(value, Math.min.apply(Math, _toConsumableArray(keys).concat([0])) - 1);
      return promisifyRequest(store.transaction);
    });
  });
}

/** Pop the oldest value from the store */
function _shift(store) {
  return store(function (store) {
    return keys(store).then(function (keys) {
      var firstKey = keys[0];
      if (firstKey == null) {
        return undefined;
      }
      return promisifyRequest(store.get(firstKey)).then(function (value) {
        store.delete(firstKey);
        return promisifyRequest(store.transaction).then(function () {
          return value;
        });
      });
    });
  });
}
function createIndexedDbStore(options) {
  var store;

  // Lazily create the store only when it's needed
  function getStore() {
    if (store == undefined) {
      store = createStore(options.dbName || 'sentry-offline', options.storeName || 'queue');
    }
    return store;
  }
  return {
    push: function () {
      var _push2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(env) {
        var serialized;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return serializeEnvelope(env);
            case 3:
              serialized = _context.sent;
              _context.next = 6;
              return _push(getStore(), serialized, options.maxQueueSize || 30);
            case 6:
              _context.next = 10;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 8]]);
      }));
      function push(_x) {
        return _push2.apply(this, arguments);
      }
      return push;
    }(),
    unshift: function () {
      var _unshift2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(env) {
        var serialized;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return serializeEnvelope(env);
            case 3:
              serialized = _context2.sent;
              _context2.next = 6;
              return _unshift(getStore(), serialized, options.maxQueueSize || 30);
            case 6:
              _context2.next = 10;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 8]]);
      }));
      function unshift(_x2) {
        return _unshift2.apply(this, arguments);
      }
      return unshift;
    }(),
    shift: function () {
      var _shift2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var deserialized;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _shift(getStore());
            case 3:
              deserialized = _context3.sent;
              if (!deserialized) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return", parseEnvelope(deserialized));
            case 6:
              _context3.next = 10;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
            case 10:
              return _context3.abrupt("return", undefined);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 8]]);
      }));
      function shift() {
        return _shift2.apply(this, arguments);
      }
      return shift;
    }()
  };
}
function makeIndexedDbOfflineTransport(createTransport) {
  return function (options) {
    var transport = createTransport(_objectSpread(_objectSpread({}, options), {}, {
      createStore: createIndexedDbStore
    }));
    WINDOW.addEventListener('online', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return transport.flush();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x3) {
        return _ref.apply(this, arguments);
      };
    }());
    return transport;
  };
}

/**
 * Creates a transport that uses IndexedDb to store events when offline.
 */
function makeBrowserOfflineTransport() {
  var createTransport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeFetchTransport;
  return makeIndexedDbOfflineTransport(makeOfflineTransport(createTransport));
}
export { createStore, makeBrowserOfflineTransport, _push as push, _shift as shift, _unshift as unshift };